import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IExpenseClaim } from 'Interfaces/expenseClaim';
import { ExpenseClaimDetailsSchema } from 'Modules/Requests/ExpenseClaim/ExpenseClaimMain/Schema';

export const useExpenseClaimForm = () => {
  const expenseClaimForm = useForm<IExpenseClaim>({
    mode: 'all',
    resolver: yupResolver(ExpenseClaimDetailsSchema),
    defaultValues: {
      travelDate: undefined,
      isPublicTransport: false,
      publicTransportPrice: undefined,
      originPlace: '',
      destinationPlace: '',
    },
  });

  return expenseClaimForm;
};
